/**
 * Главная страница = мгновенный вход в квизы (README: `/` — поле PIN + «Вести игру»).
 *
 * UX: ввод 6-значного PIN + «Присоединиться» → поток игрока; «Вести игру» →
 * поток ведущего. Предзаполнение PIN из `?pin=` (для QR-входа) делает подключение
 * по отсканированному коду одношаговым. Сохранён брендинг и теглайн Фазы 0.
 */
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { PIN_LENGTH } from '../util';

export interface HomeScreenProps {
  /** Предзаполненный PIN (из query `?pin=`). */
  initialPin?: string;
  onHost: () => void;
  onJoin: (pin: string) => void;
}

export function HomeScreen({ initialPin = '', onHost, onJoin }: HomeScreenProps): JSX.Element {
  const { t } = useTranslation();
  const [pin, setPin] = useState(initialPin);
  const valid = pin.length === PIN_LENGTH;

  function handleJoin(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    if (!valid) return;
    onJoin(pin);
  }

  return (
    <main className="card" aria-labelledby="brand">
      <h1 id="brand" className="brand">
        kikayoo
        {/* Фаза 15 (D1): доменный суффикс — приглушённый серый через --brand-dim;
            имя сохраняет градиент .brand (color: transparent + background-clip).
            data-testid — контракт e2e (проверка суффикса в DOM главной). */}
        <span className="brand__domain" data-testid="brand-domain">
          .com
        </span>
      </h1>
      <p className="tagline">{t('home.tagline')}</p>

      <form className="entry" onSubmit={handleJoin} noValidate>
        <label className="field-label" htmlFor="pin">
          {t('home.pinLabel')}
        </label>
        <input
          id="pin"
          className="pin-input"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="000000"
          maxLength={PIN_LENGTH}
          minLength={PIN_LENGTH}
          aria-describedby="pin-hint"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, PIN_LENGTH))}
        />
        <p id="pin-hint" className="hint">
          {t('home.pinHint')}
        </p>

        <button type="submit" className="cta" disabled={!valid}>
          {t('home.join')}
        </button>
        <button type="button" className="btn btn--ghost" onClick={onHost}>
          {t('home.host')}
        </button>
      </form>
    </main>
  );
}
